import { Outlet } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import AppHeader from './AppHeader';

export default function AppLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-slate-50 to-white pt-12 flex flex-col">
      <AppHeader />
      <main className="w-full px-4 sm:px-6 lg:px-8 py-6 flex-1">
        <Outlet />
      </main>
      {user && (
        <footer className="w-full px-6 py-3 border-t border-slate-200 flex items-center justify-between text-sm text-slate-400">
          <span>{user.email}</span>
          <button
            onClick={logout}
            className="text-slate-400 hover:text-red-500 transition-colors cursor-pointer"
          >
            Se déconnecter
          </button>
        </footer>
      )}
    </div>
  );
}
